























































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ContentCard from '@/web/components/products/ContentCard.vue';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import ProductToggleSection from '@/web/components/products/ProductToggleSection.vue';
import ProductEditSection from '@/web/components/products/ProductEditSection.vue';
import LibraryAddMedia from '@/web/views/admin/media-library/LibraryAddMedia.vue';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

export default Vue.extend({
  name: 'ProductDetails',
  mixins: [TeacherPermissionsMixin],
  components: {
    ContentCard,
    ProductToggleSection,
    ProductEditSection,
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      showProductCustomFields: 'user/showProductCustomFields',
      productTags: 'product/productTags',
    }),
    productName: {
      get() {
        return this.productForm.product_name;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', { product_name: value });
      },
    },
    coverFile: {
      get(): PhotoResponse {
        return this.productForm.cover_file;
      },
      set(value: PhotoResponse): void {
        this.$store.dispatch('product/setProductForm', {
          cover_file: value,
        });
      },
    },
    thumbnailFile: {
      get(): PhotoResponse {
        return this.productForm.thumbnail_file;
      },
      set(value: PhotoResponse): void {
        this.$store.dispatch('product/setProductForm', {
          thumbnail_file: value,
        });
      },
    },
    productDescription: {
      get() {
        return this.productForm.product_description;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description: value,
        });
      },
    },
    productDescriptionNew: {
      get(): string {
        return this.productForm.product_description_new;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description_new: value,
        });
      },
    },
    custom1: {
      get(): string {
        return this.productForm.custom1;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom1: value,
        });
      },
    },
    custom2: {
      get(): string {
        return this.productForm.custom2;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom2: value,
        });
      },
    },
    custom3: {
      get(): string {
        return this.productForm.custom3;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom3: value,
        });
      },
    },
    mediaNewTagDays: {
      get(): number {
        return this.productForm.media_new_tag_days as number;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          media_new_tag_days: value,
        });
      },
    },
    freeSample: {
      get(): boolean {
        return this.productForm.free_sample;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          free_sample: value,
        });
      },
    },
    freeSampleDescription: {
      get(): string {
        return this.productForm.free_sample_description;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          free_sample_description: value,
        });
      },
    },
    freeSampleDescriptionNew: {
      get(): string {
        return this.productForm.free_sample_description_new;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          free_sample_description_new: value,
        });
      },
    },
    freeSampleMedia: {
      get(): SampleMediaResponse[] {
        return this.productForm.free_sample_media;
      },
      set(value: SampleMediaResponse[]) {
        this.$store.dispatch('product/setProductForm', {
          free_sample_media: value,
        });
      },
    },
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
    isBundle() {
      return this.productForm.product_type === 'bundle';
    },
  },
  methods: {
    async showAddMediaForm(): Promise<void> {
      this.$modal.show(
        MediaFormModal,
        {
          showSelectMedia: true,
          showEditMedia: false,
          videoUploadAllowed: this.videoUploadAllowed,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'media-selected': async (content: any[]) => {
            this.freeSampleMedia = [...this.freeSampleMedia, ...content];
          },
          'media-added': medaiData => {
            this.openNewMedia(medaiData);
          },
        }
      );
    },
    async openNewMedia(medaiData) {
      this.$modal.show(
        LibraryAddMedia,
        {
          medaiData,
          showAsModal: true,
        },
        { classes: ['vm--inline-modal'] },
        {
          'media-saved': async media => {
            this.freeSampleMedia = [media, ...this.freeSampleMedia];
          },
        }
      );
    },
    removeLessonContent(id: number): void {
      this.freeSampleMedia = this.freeSampleMedia.filter(c => c.id != id);
    },
  },
});
